var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.nbPages > 1
    ? _c("div", { staticClass: "pagination-wrapper" }, [
        _c(
          "span",
          {
            staticClass: "first",
            class: { disabled: _vm.isFirst },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.handle("first")
              },
            },
          },
          [
            _c("i", { staticClass: "fa fa-chevron-left" }),
            _vm._v(" "),
            _c("i", { staticClass: "fa fa-chevron-left" }),
          ]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "prev",
            class: { disabled: _vm.isFirst },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.handle("prev")
              },
            },
          },
          [_c("i", { staticClass: "fa fa-chevron-left" })]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "page-infos",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.togglePagesList($event)
              },
            },
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("global.page")) +
                " " +
                _vm._s(_vm.currentPage) +
                " " +
                _vm._s(_vm.$t("global.pageSeparator")) +
                " " +
                _vm._s(_vm.nbPages) +
                " "
            ),
            _c("i", { staticClass: "fa fa-caret-up" }),
          ]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "next",
            class: { disabled: _vm.isLast },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.handle("next")
              },
            },
          },
          [_c("i", { staticClass: "fa fa-chevron-right" })]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "last",
            class: { disabled: _vm.isLast },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.handle("last")
              },
            },
          },
          [
            _c("i", { staticClass: "fa fa-chevron-right" }),
            _vm._v(" "),
            _c("i", { staticClass: "fa fa-chevron-right" }),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "on-clickaway",
                rawName: "v-on-clickaway",
                value: _vm.closePagesList,
                expression: "closePagesList",
              },
            ],
            staticClass: "pages-list",
            class: { show: _vm.showPageList },
          },
          [
            _c(
              "ul",
              { staticClass: "scroll" },
              _vm._l(_vm.nbPages, function (n) {
                return _c(
                  "li",
                  {
                    class: { active: n == _vm.currentPage },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.go(n)
                      },
                    },
                  },
                  [_vm._v("Page " + _vm._s(n))]
                )
              }),
              0
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }